<template>
<div>
    <!-- modal -->
    <b-modal id="lawCounterPartySubTypeFormModal" centered size="lg" no-close-on-backdrop ref="lawCounterPartySubTypeFormModal" :title=" $t('lawCounterPartySubType.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
        <b-row>
            <b-col class="col-lg-6">
                            <b-form-group>
                                    <label>{{ $t('lawCounterPartySubType.law_counter_party_type_name')  }}</label>
                                    <validation-provider v-slot="{ errors }" :name="$t('lawCounterPartySubType.law_counter_party_type_name')" :rules="{ excluded:0}" >
                                    <b-form-select size="sm" v-model="lawCounterPartyTypeSelect" value-field="id" text-field="name" :options="lawCounterPartyTypeList" :state="errors.length > 0 ? false:null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
            </b-col>
            <b-col class="col-lg-6" >
                <b-form>
                <label for="law-counter-party-sub-type-name-input">{{ $t('lawCounterPartySubType.type') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('lawCounterPartySubType.type')" rules="required">
                        <b-form-input id="law-counter-party-sub-type-name-input" v-model="name" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
            </b-col>
        </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawCounterPartySubTypeList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            lawCounterPartyTypeList: [],
            lawCounterPartyTypeSelect: 0
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawCounterPartySubTypeFormModal'].show()
            this.id = id

            const data = {id: this.id }
            const controller = {  name: 'LawCounterPartySubType'}
            const payload = { data: data,controller: controller  }

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.lawCounterPartyTypeList = response.data.lawCounterPartyTypeList
                    this.lawCounterPartyTypeList.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartyTypeSelect = response.data.lawCounterPartySubType.lawCounterPartyTypeId
                    this.name = response.data.lawCounterPartySubType.name
                } else {
                    this.$bvModal.hide('lawCounterPartySubTypeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        async addOrUpdate() {

            const data = {id: this.id, name: this.name, lawCounterPartyTypeId: this.lawCounterPartyTypeSelect}
            const controller = {name: 'LawCounterPartySubType' }
            const payload = {  data: data, controller: controller }

            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawCounterPartySubTypeFormModal')
                            this.getLawCounterPartySubTypeList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
